import { OktaAuth } from '@okta/okta-auth-js';
import { environment as ENV } from '@env/environment';

const hostname = window.location.hostname;

const config = hostname.includes('aaa.com') || hostname.includes('b2cacmic') ? {
  issuer: ENV.OKTA.AAA.ISSUER + '/oauth2/default',
  clientId: ENV.OKTA.AAA.CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  tokenManager: {
    storage: 'localStorage',
    autoRenew: false,
    expireEarlySeconds: 3600
  }
} : {
  issuer: ENV.OKTA.MAPFRE.ISSUER + '/oauth2/default',
  clientId: ENV.OKTA.MAPFRE.CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  tokenManager: {
    storage: 'localStorage',
    autoRenew: false,
    expireEarlySeconds: 3600
  }
};

export const oktaAuth = new OktaAuth(config);